module.exports = __webpack_public_path__ + "static/media/HindVadodara-Light.5e2663e4.ttf";